import { X } from "lucide-react";
import { LoginForm } from "./LoginForm";

type Props = {
  onClose: () => void;
  onSuccess: () => void;
};

export function LoginModal({ onClose, onSuccess }: Props) {
  return (
    <div
      className="login-modal-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="login-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="login-modal-title"
        dir="rtl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="login-modal-header">
          <div className="login-modal-brand">
            <img src="/brand/nevisign-logo.svg" alt="" className="brand-mark" />
            <div>
              <h2 id="login-modal-title">برای استفاده از این سرویس وارد شوید</h2>
              <p className="settings-hint">
                همان حساب پنل نویساین برای ادامه در کارتابل، قراردادها و ابزارهای هوشمند
              </p>
            </div>
          </div>
          <button
            type="button"
            className="icon-btn compact"
            aria-label="بستن"
            onClick={onClose}
          >
            <X size={18} />
          </button>
        </div>
        <div className="login-modal-body">
          <div className="hero-art" style={{ maxWidth: "13rem", marginBottom: "0.85rem" }}>
            <img src="/illustrations/welcome-hero.svg" alt="تصویر ورود نویساین" />
          </div>
          <LoginForm onSuccess={onSuccess} />
        </div>
      </div>
    </div>
  );
}
